angular.module('app.entity.audit')
    .filter('historyLabel', [
        '$filter',
        'gettextCatalog',
        'CrdConfigurationService',
        function(
            $filter,
            gettextCatalog,
            CrdConfigurationService
        ) {
            /**
             * Devuelve la etiqueta del campo formateada, según la información del cambio que se le pasa
             *
             * @param  {object} change Cambio completo (label, flag, value, etc.)
             *
             * @return {string}        Etiqueta legible descriptiva del objetivo del cambio
             */
            return function(change) {
                var formattedLabel = '';

                // si es global
                if (change.action == 'global-metadata') {
                    formattedLabel = CrdConfigurationService.getLabelSingular();
                    if (angular.isArray(change.label)) {
                        formattedLabel = $filter('elementLabel')([formattedLabel].concat(change.label));
                    }
                } else if (change.label) {
                    // change.label es un array con la etiqueta de cada componente del path
                    formattedLabel = $filter('elementLabel')(change.label);
                }

                if (change.flag === 'locked') {
                    formattedLabel += ' ⇢ ' + gettextCatalog.getString('Bloqueado');
                }

                return formattedLabel;
            };
        }]);
